import { FormControlLabel, Radio, RadioGroup, Stack, TextField } from '@mui/material';
import { useValidationRules } from '@utils/useValidationRules';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { FormEditorFieldValues } from '../../types';
import { InlineEditableComponentProps } from '../DraggableFormField';
import { FormFieldLabel } from '../FormFieldLabel';

type Props = InlineEditableComponentProps;

export const BooleanFormFieldConfiguration = (props: Props) => {
  const { formatMessage } = useIntl();
  const { notEmpty } = useValidationRules();

  const { control } = useFormContext<FormEditorFieldValues>();

  const question = useWatch({ control: control, name: 'name' });
  const required = useWatch({ control: control, name: 'isRequired' });

  const sampleControl = (
    <RadioGroup row>
      <FormControlLabel value="yes" control={<Radio />} disabled label={formatMessage({ id: 'Yes' })} />
      <FormControlLabel value="no" control={<Radio />} disabled label={formatMessage({ id: 'No' })} />
    </RadioGroup>
  );

  return props.isActive ? (
    <Stack p={2} gap={1}>
      <Controller
        name='name'
        control={control}
        rules={{ validate: notEmpty }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            autoFocus
            fullWidth
            required
            error={Boolean(error)}
            helperText={error?.message}
            label={formatMessage({ id: 'Question' })}
          />
        )}
      />

      {sampleControl}
    </Stack>
  ) : (
    <Stack p={2}>
      <FormFieldLabel required={required} italic={!question}>
        {question || formatMessage({ id: 'No name set' })}
      </FormFieldLabel>

      {sampleControl}
    </Stack>
  );
};